/**
 * Function naming convention: api{FunctionName}
 * File naming convention: {FunctionName}.ts
 */

export function apiGetUrlWithParams(url: string, params: unknown): string {
  const paramsAsQuery = new URLSearchParams(params as Record<string, string>);
  const paramsAsString = paramsAsQuery.toString();

  return paramsAsString ? `${url}?${paramsAsString}` : url;
}
